export class CommSummaryModel {

    public commPlanId: any;
    public salesChannel: string;
    public country: string;
    public commPlan: string;
    public calendarType: string;
    public validToDt: Date;
    public validFromDt: Date;
    public calRunId: string;
    public calRunIds: string[]; 
    public field_value: string;
    public sc_emp_id: string;
    public extra_sc_emp_id: number;
    public effective_date: Date;
    public comm_plan_id: any;
    public extra_comm_plan_id: number;
    public sup_sc_emp_id: string;
    public sup_extra_sc_emp_id: number;
    public checkboxstatus: boolean;
    public issalesrepaccess: string;
    public reporttype: string;
    public display_flag: string;
    public pay_dt: Date;
    public comm_plan: string;
    public field_short_name: string;
    public userRole: string;
   // public assignedSalesChannel: string;

    constructor() {
        this.field_short_name = null;
        this.comm_plan = null;
        this.pay_dt = null;
        this.display_flag = null;
        this.validFromDt = null;
        this.reporttype = null;
        this.issalesrepaccess = null;
        this.checkboxstatus = null;
        this.extra_comm_plan_id = null;
        this.commPlanId = null;
        this.salesChannel = "";
        this.country = "";
        this.commPlan = "";
        this.calendarType = "";
        this.validToDt = null;
        this.calRunId = "";
        this.calRunIds = null;
        this.field_value = "";
        this.sc_emp_id = "";
        this.extra_sc_emp_id = 0;
        this.sup_sc_emp_id = "";
        this.sup_extra_sc_emp_id = 0;
        this.effective_date = null;
        this.comm_plan_id = null;
        this.userRole = null;
       // this.assignedSalesChannel = null;
    }
}
